/** Turns URLs inside plain text into clickable links. */
export const linkify = (text) => {
  if (!text) return text;
  const parts = String(text).split(/(https?:\/\/[^\s<>"']+)/g);
  return parts.map((part, i) => {
    if (!/^https?:\/\//.test(part)) return part;
    const clean = part.replace(/[.,;:)\]]+$/, "");
    const trail = part.slice(clean.length);
    return (
      <span key={i}>
        <a
          href={clean}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline break-all hover:text-blue-800"
        >
          {clean}
        </a>
        {trail}
      </span>
    );
  });
};
